export default __webpack_public_path__ + "static/mar-bc7b96ee282a51131f81063604e09ea3.jpg";